import { FC } from 'react'
import CustomButton from '../UI/Buttons/CustomButton'
import SignoutIcon from '../UI/Icons/SignOut'
import SupportIcon from '../UI/Icons/SupportIcon'
import CustomPopup from '../UI/Popup'

import './SupportButton.scss'

type TSupportButtonProps = {}

const SupportButton: FC<TSupportButtonProps> = ({ }) => {

    const moveToExternal = () => {
        window.open('https://support.attentionnest.com/', '_blank');
    }

    return (
        <CustomPopup
            keepTooltipInside='body'
            className='support-button-popup'
            position='right bottom'
            // isShowPopup={true}
            isOpen={true}
            trigger={() => (
                <div className='support-button'>
                    <SupportIcon />
                </div>
            )}>
            <div className='support-button-popup__buttons'>
                <CustomButton
                    onClick={moveToExternal}
                    className='support-button-popup__actions__general'
                    button='add-subtle'
                >
                    <SignoutIcon /> Go To Support
                </CustomButton>
            </div>
        </CustomPopup>
    )
}

export default SupportButton